import type { NavItem } from "./app-sidebar";

/** Feature pages outside settings, shared by the sidebar's Apps group and the command bar. */
export const featureNavItems: Array<NavItem> = [
  {
    title: "Forms",
    url: "/p/forms",
    icon: "FileText",
    id: "forms",
    type: "entity",
    requiresEntity: "PyloForm",
  },
  {
    title: "Flows",
    url: "/p/flows",
    icon: "Workflow",
    id: "flows",
    type: "entity",
    requiresEntity: "PyloFlow",
  },
  {
    title: "Media",
    url: "/p/media",
    icon: "Images",
    id: "media",
    type: "entity",
    requiresEntity: "PyloMedia",
  },
  {
    title: "Proposals",
    url: "/p/proposals",
    icon: "ClipboardCheck",
    id: "proposals",
    type: "entity",
    requiresEntity: "PyloProposal",
  },
  {
    title: "Dashboards",
    url: "/p/dashboard",
    icon: "LayoutDashboard",
    id: "dashboards",
    type: "entity",
    // Opt-in feature: the entity only exists once activated in Settings → Features.
    requiresEntity: "Dashboard",
  },
  // Hidden from the main nav while still in development. The page is still
  // reachable via the direct URL /p/events.
  // {
  //   title: 'Events',
  //   url: '/p/events',
  //   icon: 'Activity',
  //   id: 'events',
  //   type: 'entity',
  // },
];
